import React, { FC } from 'react';
import Card from 'src/components/Card';
import { Box } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

const FeedEvent: FC = () => {
  return (
    <Card>
      <Box display='flex' flexDirection='row'>
        <Box clone mr={1}>
          <Skeleton variant='circle' width={50} height={50} />
        </Box>

        <Box display='flex' flexDirection='column' flexGrow={1}>
          <Box mb={1} pr={20} clone>
            <Skeleton variant='rect' width='70%' />
          </Box>
          <Box clone>
            <Skeleton variant='rect' width='60%' />
          </Box>
        </Box>

        <Box ml={1} clone>
          <Skeleton variant='rect' width={60} />
        </Box>
      </Box>
    </Card>
  );
};

export default FeedEvent;
